module.exports = __webpack_public_path__ + "img/img_32389_0_153.5fac7c68.png";